import { createFileRoute } from "@tanstack/react-router";
import Page, { seo } from "@/pages/services/marketing";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/services/marketing")({
  head: () => buildServiceHead(seo),
  component: Page,
});
